// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3RbHz","comment":"styles_comment__1LPbZ"};